import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSAPDataStore } from '../../store/SAPDataStore';
import { useThemeClasses } from '../../providers/ThemeProvider';

// Simple cx utility for combining class names
const cx = (...classes: (string | undefined | null | false)[]): string => {
  return classes.filter(Boolean).join(' ');
};

interface HomeFilterBarProps {
  label?: string;
}

const HomeFilterBar: React.FC<HomeFilterBarProps> = ({ label }) => {
  const { t } = useTranslation();
  const { showOnlyWithData, setShowOnlyWithData } = useSAPDataStore();
  const themeClasses = useThemeClasses();
  
  const displayLabel = label || t('showAllMachines') || 'Show all machines';
  
  return (
    <div className="flex items-center space-x-3">
      <span className={cx(themeClasses.textSecondary, "text-sm font-medium")}>{displayLabel}</span>
      <button
        type="button"
        onClick={() => setShowOnlyWithData(!showOnlyWithData)}
        className={cx(
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
          showOnlyWithData 
            ? "bg-blue-600" 
            : cx(themeClasses.bgSecondary, "border border-gray-300")
        )}
        role="switch"
        aria-checked={showOnlyWithData}
        aria-label={displayLabel}
      >
        <span
          className={cx(
            "inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out shadow-sm",
            showOnlyWithData 
              ? "translate-x-6" 
              : "translate-x-1"
          )}
        />
      </button>
    </div>
  );
};

export default HomeFilterBar;
